import { render, staticRenderFns } from "./globalset.vue?vue&type=template&id=a6724af0&scoped=true"
import script from "./globalset.vue?vue&type=script&lang=js"
export * from "./globalset.vue?vue&type=script&lang=js"
import style0 from "./globalset.vue?vue&type=style&index=0&id=a6724af0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6724af0",
  null
  
)

export default component.exports